module.exports = __webpack_public_path__ + "img/16l006-01.2ced4887.jpg";